/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { Caregiver } from '../models/Caregiver';
import type { GetStipendRequestDto } from '../models/GetStipendRequestDto';
import type { PatientSummaryViewModel } from '../models/PatientSummaryViewModel';
import type { ReimbursementRequest } from '../models/ReimbursementRequest';
import type { RequestSummary } from '../models/RequestSummary';
import type { TravelRequest } from '../models/TravelRequest';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PatientService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param patientId
     * @param withClintrackStatus
     * @returns PatientSummaryViewModel
     * @throws ApiError
     */
    public patientGetPatientDetailsById(
        patientId: number,
        withClintrackStatus?: boolean,
    ): Observable<PatientSummaryViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/patients/{patientId}/detailed',
            path: {
                'patientId': patientId,
            },
            query: {
                'withClintrackStatus': withClintrackStatus,
            },
        });
    }
    /**
     * @param patientId
     * @returns boolean
     * @throws ApiError
     */
    public patientIsPatientInPatientPortal(
        patientId: number,
    ): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/patients/{patientId}/patientPortalAccess',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns RequestSummary
     * @throws ApiError
     */
    public patientGetPatientAccessibleRequestsSummaries(
        patientId: number,
    ): Observable<Array<RequestSummary>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/patients/{patientId}/requestSummaries',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns TravelRequest
     * @throws ApiError
     */
    public patientGetPatientTravelRequests(
        patientId: number,
    ): Observable<TravelRequest> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/patients/{patientId}/requests/travel',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns ReimbursementRequest
     * @throws ApiError
     */
    public patientGetPatientReimbursementRequests(
        patientId: number,
    ): Observable<ReimbursementRequest> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/patients/{patientId}/requests/reimbursement',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns GetStipendRequestDto
     * @throws ApiError
     */
    public patientGetPatientStipendRequests(
        patientId: number,
    ): Observable<Array<GetStipendRequestDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/patients/{patientId}/requests/stipend',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns binary
     * @throws ApiError
     */
    public patientGetCaregiversByPatientId(
        patientId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/patients/{patientId}/caregivers',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public patientCreateCaregiver(
        requestBody: Caregiver,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/patients/caregiver',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public patientUpdateCaregiver(
        requestBody: Caregiver,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/patients/caregiver',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
